exports = module.exports = require("../../../app/node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", "",{"version":3,"sources":[],"names":[],"mappings":"","file":"footer.vue"}]);



//////////////////
// WEBPACK FOOTER
// ../app/node_modules/css-loader/dist/cjs.js?{"sourceMap":true}!../app/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c4d8baa","scoped":false,"hasInlineConfig":false}!../app/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/footer.vue
// module id = Ksr7
// module chunks = 0